export const Divider = () => <div className="divider"></div>;